<template lang="pug">

div.u-mt-md.u-mb-md
  section
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    Query(
      :query="require('~/graphql/Career.gql').Careers"
      :limit="6"
      :initialValue="careers"
      :variables="({ first, after }) => ({ first, after, isPublished: true, isArchived: false })"
      v-slot="{ items }"
    )
      CareersCard(v-for="career,idx in items" :key="idx" :data="career")

</template>

<script>
import { Careers } from '~/graphql/Career.gql';
import Query from '~/components/Query';
import AsymetricGrid from '~/components/PsudoRandomGrid';
import CareersCard from '~/components/CareersCard';

export default {
  scrollToTop: true,
  methods: {
    getBranchName(item) {
      return item.branchObj ? item.branchObj.name : '';
    }
  },
  head() {
    const $t = this.$t.bind(this);

    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: '{CDN_URL}/share/careers.jpg'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: '{CDN_URL}/share/careers.jpg'
        }
      ]
    };
  },
  components: {
    Query,
    AsymetricGrid,
    CareersCard
  },
  async asyncData({ app }) {
    const { data } = await app.$api.query({
      query: Careers,
      variables: {
        first: 6,
        isPublished: true,
        isArchived: false
      }
    });

    return { careers: data.careers };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat opportunities",
    "pageDesc":"See all the open opportunities inside Baianat and apply to join our team.",
    "mantra":"Discover our open |opportunities."
  },
  "ar": {
    "pageTitle":"الفرص المتاحة",
    "pageDesc":"قم بالاطلاع على كل الفرص المتاحة داخل بيانات وتقدم للانضمام إلى فريقنا.",
    "mantra":"اكتشف جميع |الفرص المتاحة."
  }
}
</i18n>
